import Admin from "../Admin";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from '@mui/material/MenuItem';
import MUIListItemIcon from '@mui/material/ListItemIcon';
import Validator from "../../../Utility/Validator";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import CardAdminFeeScheduleGeneral from "../../../Component/Card/Admin/FeeSchedule/CardAdminFeeScheduleGeneral";
import FeeSchedule from "../../../Utility/Crud/FeeSchedule";
import FeeScheduleService from "../../../Seating/Security/FeeScheduleService/feeScheduleService";

export default class FeeScheduleCreateEdit extends Admin {
    constructor(props) {
        super(props);

        this.state.feeSchedule = null;
        this.state.isProcessing = false;
        this.state.isUpdate = !!props.match.params.id;
        this.state.confirmDialogOpen = false;
        this.state.validationIssues = {};
    }

    /**
     * Set the feeSchedule in the state.
     */
    afterComponentDidMount() {
        const feeScheduleId = this.props.match.params.id ? +this.props.match.params.id : null;
        if (feeScheduleId !== null) {
            this.setState({
                feeSchedule: this.context.feeSchedulesIndexed[feeScheduleId]
            });
        }
    }

    /**
     * Creates the feeSchedule with the current properties in state.feeSchedule.
     */
    async createFeeSchedule() {
        this.setState({
            isProcessing: true,
        });

        return FeeScheduleService.createFeeSchedule(this.state.feeSchedule)
            .then(feeSchedule => {
                this.context.updateIndexed("feeSchedulesIndexed", feeSchedule);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Fee Schedule created successfully!", { variant: "success" });
            })
            .catch((err) => {
                // JZ. We need to test and make sure that Sentry still captures
                // errors when we catch them in the application.
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error creating a new Fee Schedule.", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    /**
     * Updates the feeSchedule with the current properties in state.feeSchedule.
     */
    async updateFeeSchedule() {
        this.setState({
            isProcessing: true,
        });

        return FeeScheduleService.updateFeeSchedule(this.state.feeSchedule)
            .then(feeSchedule => {
                this.context.updateIndexed("feeSchedulesIndexed", feeSchedule);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Fee Schedule updated successfully!", { variant: "success" });
            })
            .catch(err => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error updating the Fee Schedule.", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    async deleteFeeSchedule() {
        this.setState({
            isProcessing: true,
        });

        return FeeScheduleService.deleteFeeSchedule(this.state.feeSchedule.id)
            .then(() => {
                this.context.deleteIndexed("feeSchedulesIndexed", this.state.feeSchedule.id);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Fee Schedule deleted successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error deleting the Fee Schedule.", { variant: "error" });
                this.setState({
                    confirmDialogOpen: false,
                });
            });
    }

    /**
     * Render the content.
     */
    renderContent() {
        const handleChange = (feeSchedule) => {
            this.setState({
                feeSchedule: {
                    ...this.state.feeSchedule,
                    ...feeSchedule
                },
            });
        };

        return (
            <>
                <CardAdminFeeScheduleGeneral
                    feeSchedule={this.state.feeSchedule}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <DialogConfirm
                    open={this.state.confirmDialogOpen}
                    onClose={() => this.setState({ confirmDialogOpen: false })}
                    onConfirm={() => this.deleteFeeSchedule()}
                    text="Are you sure you want to delete this Fee Schedule? This cannot be undone."
                    header="Delete Fee Schedule"
                    loading={this.state.isProcessing}
                />
            </>
        );
    }

    /**
    * Renders the header.
    */
    renderHeader() {
        let title;
        let subtitle;
        const buttonText = this.state.isUpdate ? "Save" : "Create";

        if (!this.state.isUpdate) {
            title = "Create Fee Schedule";
            subtitle = null;
        } else {
            title = "Edit Fee Schedule";
            subtitle = (this.state.feeSchedule && (FeeSchedule.getDisplayName(this.state.feeSchedule) + " • " + this.state.feeSchedule.id));
        }

        const handleClickBack = () => {
            this.props.history.goBack();
        };

        const handleClickSave = () => {
            const validationIssues = Validator.validate(
                this.state.feeSchedule,
                {
                    hcpcsCodeId: {
                        'required': true
                    },
                    amount: {
                        'required': true
                    },
                }
            );

            this.setState({
                validationIssues: validationIssues,
            });


            if (Object.keys(validationIssues).length > 0) {
                return NotistackEnqueueSnackbar("Please correct the displayed issues.", { variant: "error" });
            }

            if (Object.keys(validationIssues).length === 0) {
                if (this.state.isUpdate) {
                    this.updateFeeSchedule();
                } else {
                    this.createFeeSchedule();
                }
            }

        };

        const handleDelete = () => {
            this.setState({
                confirmDialogOpen: true,
            });
        };

        const buttons = [
            (<MUIButton onClick={handleClickBack}>Back</MUIButton>),
            (
                <MUILoadingButton
                    loading={this.state.isProcessing}
                    loadingPosition="start"
                    onClick={handleClickSave}
                    variant="contained"
                    startIcon={<MUISaveButton />}>
                    {buttonText}
                </MUILoadingButton>
            )
        ];

        if (this.state.isUpdate) {
            const menuItems = [
                (
                    <MUIMenuItem onClick={handleDelete}>
                        <MUIListItemIcon>
                            <MUIDeleteIcon fontSize="small" />
                        </MUIListItemIcon>
                        Delete
                    </MUIMenuItem>
                )
            ];
            buttons.push((<Menu menuItems={menuItems} />));
        }

        return (
            <PageHeader title={title} subtitle={subtitle} buttons={buttons} />
        );
    }
}
